import { useLanguage } from "@/context/LanguageContext";
import { content, images } from "@/i18n/content";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { avifSrc, isLocalPhoto, webpSrc } from "@/lib/media";

const About = () => {
  const { pick, lang } = useLanguage();
  return (
    <section id="about" data-testid="about-section" className="bg-[#F7F5F0] py-24 md:py-32 lg:py-40">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-24">
        <SectionHeading
          eyebrow={pick(content.about.eyebrow)}
          heading={pick(content.about.headline)}
        />
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <Reveal className="lg:col-span-5" y={60}>
            <div className="relative">
              <div className="absolute -top-4 -left-4 h-full w-full border border-[#C42021]" aria-hidden="true" />
              <div className="relative overflow-hidden">
                <picture>
                  {isLocalPhoto(images.portrait) && (
                    <>
                      <source srcSet={avifSrc(images.portrait)} type="image/avif" />
                      <source srcSet={webpSrc(images.portrait)} type="image/webp" />
                    </>
                  )}
                  <img
                    src={images.portrait}
                    alt={pick(content.about.caption)}
                    loading="lazy"
                    className="aspect-square w-full object-cover transition-transform duration-[1200ms] ease-out hover:scale-[1.04]"
                  />
                </picture>
              </div>
              <p className="mt-5 text-xs uppercase tracking-[0.2em] text-[#4A4A4A]">
                {pick(content.about.caption)}
              </p>
            </div>
          </Reveal>

          <div className="lg:col-span-7 lg:pt-2">
            {content.about.paragraphs[lang].map((p, i) => (
              <Reveal key={i} delay={0.1 + i * 0.1}>
                <p className="body-lg leading-relaxed text-[#171717]/85 mb-8 max-w-3xl">{p}</p>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <blockquote className="mt-4 border-l-2 border-[#C42021] pl-6 md:pl-8">
                <p className="font-display italic text-xl md:text-3xl leading-snug text-[#171717]">
                  “{pick(content.about.quote)}”
                </p>
                <footer className="mt-4 text-xs font-semibold uppercase tracking-[0.22em] text-[#4A4A4A]">
                  {pick({ en: "Sanjay Sharma", hi: "संजय शर्मा" })}
                </footer>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
